// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"PaymentMadeModal_modalContainer__3E5ob","modalMessage":"PaymentMadeModal_modalMessage__2ylfo","modalButton":"PaymentMadeModal_modalButton__p2W21"};